import type { MailTemplateModel } from "./MailTemplateModel";
import type {
  CommunicationSettings,
  MailPlaceholderDefinition,
  MailTemplate,
  MailTemplateType,
} from "./MailTemplate.typed";

export class MailTemplateAdapter {
  constructor(private model: MailTemplateModel) {}
  async listMailTemplates(type?: MailTemplateType): Promise<MailTemplate[]> {
    return this.model.listMailTemplates(type);
  }
  async getMailTemplate(id: number): Promise<MailTemplate> {
    return this.model.getMailTemplate(id);
  }
  async createMailTemplate(payload: MailTemplate): Promise<MailTemplate> {
    return this.model.createMailTemplate(payload);
  }
  async updateMailTemplate(id: number, payload: MailTemplate): Promise<void> {
    return this.model.updateMailTemplate(id, payload);
  }
  async deleteMailTemplate(id: number): Promise<void> {
    return this.model.deleteMailTemplate(id);
  }
  async listMailPlaceholderDefinitions(
    templateType: MailTemplateType,
  ): Promise<MailPlaceholderDefinition[]> {
    return this.model.listMailPlaceholderDefinitions(templateType);
  }
  async previewMailTemplateHtml(bodyHtml: string, type: MailTemplateType): Promise<string> {
    return this.model.previewMailTemplateHtml(bodyHtml, type);
  }
  async getCommunicationSettings(): Promise<CommunicationSettings> {
    return this.model.getCommunicationSettings();
  }
  async updateCommunicationSettings(payload: CommunicationSettings): Promise<void> {
    return this.model.updateCommunicationSettings(payload);
  }
}
